<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-card>
            <el-form
                :model="voucherQueryModel"
                label-width="120px"
                label-position="left"
            >
                <div>
                    <el-row :gutter="20" style="padding-bottom: 15px">
                        <el-col :span="16">
                            <div class="menu-up">
                                <span class="font-14 right-20">系统模块:</span>

                                <el-button
                                    v-for="(item, index) in moduleList"
                                    :key="index"
                                    size="medium"
                                    :type="
                                        CurrnetMID == item.id ? 'primary' : ''
                                    "
                                    @click="statusSearch(item)"
                                    >{{ item.name }}</el-button
                                >
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <el-button
                                type
                                size="mini"
                                icon="el-icon-search"
                                class="pull-right"
                                @click="search"
                                >查询</el-button
                            >
                            <el-radio-group
                                v-model="isAll"
                                size="mini"
                                class="pull-right right-20"
                            >
                                <el-radio-button label="false"
                                    >显示失败项</el-radio-button
                                >
                                <el-radio-button label="true"
                                    >显示成功项</el-radio-button
                                >
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="品牌" label-width="80px">
                                <el-select
                                    v-model="brandID"
                                    placeholder="选择品牌"
                                    size="mini"
                                    class="width100"
                                    @change="brandChange"
                                    filterable
                                    clearable
                                >
                                    <el-option
                                        v-for="item in brandList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="门店" label-width="80px">
                                <el-select
                                    v-model="voucherQueryModel.storeID"
                                    placeholder="选择门店"
                                    size="mini"
                                    class="width100"
                                    filterable
                                    clearable
                                >
                                    <el-option
                                        v-for="item in storesList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="记录日期" label-width="80px">
                                <el-date-picker
                                    v-model="time"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="业务日期" label-width="80px">
                                <el-date-picker
                                    v-model="businesstime"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    align="right"
                                    size="mini"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="padding-bottom: 10px">
                        <el-col>
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-download"
                                class="pull-left"
                                @click="voucherCreateNew"
                                v-show="isPos"
                                >重新生成凭证</el-button
                            >
                        </el-col>
                    </el-row>
                </div>
            </el-form>

            <el-table
                :data="tableData"
                size="mini"
                style="width: 100%; overflow: auto"
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                    prop="storeCode"
                    label="门店编号"
                    min-width="80px"
                ></el-table-column>
                <el-table-column
                    prop="storeName"
                    label="门店名称"
                ></el-table-column>
                <el-table-column
                    prop="userName"
                    label="操作人"
                ></el-table-column>
                <el-table-column prop="creationTime" label="操作时间">
                    <template slot-scope="scope">{{
                        timeFormat1(scope.row.creationTime)
                    }}</template>
                </el-table-column>
                <el-table-column prop="source" label="来源"></el-table-column>
                <el-table-column
                    v-if="isCloud"
                    prop="orderTypeID"
                    label="单据类型"
                ></el-table-column>
                <el-table-column
                    v-if="isCloud"
                    prop="orderTypeName"
                    min-width="100px"
                    label="单据类型名称"
                ></el-table-column>
                <el-table-column label="业务开始时间" min-width="110px">
                    <template slot-scope="scope">{{
                        timeFormat(scope.row.startTime)
                    }}</template>
                </el-table-column>
                <el-table-column label="业务结束时间" min-width="110px">
                    <template slot-scope="scope">{{
                        timeFormat(scope.row.endTime)
                    }}</template>
                </el-table-column>
                <el-table-column
                    prop="exception"
                    label="消息"
                    max-width="80%"
                    min-width="300px"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.voucherSaveJson"
                            @click="downloadFile(scope.row)"
                            type="success"
                            size="small"
                            >下载报文</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="DataApi"
                :GetData="getTableData"
                :queryParam="queryParam"
                :isInit="false"
                :errorFunc="errorHandler"
            ></pagerBar>
        </el-card>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    name: 'voucherLogs',

    data() {
        return {
            isPos: false,
            isCloud: false,
            openloading: true,
            isVoucherCreate: false,
            queryParam: {},
            CurrnetMID: 0,
            VoucherCreateApi: config.BASE_Middle_API + 'voucherManager',
            DataApi: config.BASE_Middle_API + 'VoucherLogs/GetAll', //获取源数据接口 需提供
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            tableData: [],
            accountList: [],
            time: [],
            businesstime: [],
            voucherQueryModel: {
                startTime: '',
                endTime: '',
                storeID: '',
                businessStartTime: '',
                businessEndTime: ''
            },
            brandID: '',
            isAll: false,
            VoucherCreateNewUrl:
                config.BASE_Middle_API + 'VoucherLogs/CreateNewVoucher',
            selOrder: [],
            selOrderIds: [],
            downLoadUrl:
                config.BASE_Middle_API + 'VoucherLogs/DownLoadVoucherTxt'
        }
    },
    components: { pagerBar },
    mounted() {
        this.getModules()
    },
    methods: {
        downloadFile(config) {
            let requestConfig = {
                headers: {
                    'Content-Type': 'application/json;application/octet-stream'
                }
            }
            AjaxHelper.post(
                this.downLoadUrl + '?id=' + config.id,
                requestConfig,
                {
                    responseType: 'blob'
                }
            ).then((res) => {
                // 处理返回的文件流
                const content = res
                const blob = new Blob([content])
                const fileName = config.storeName + '.txt'
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },

        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeFormat1(val) {
            return moment(val).format('YYYY-MM-DD HH:mm:ss')
        },
        voucherCreateNew() {
            const _this = this
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v.hangfireVoucher.id)
                    })
                }
            })
            if (_this.selOrderIds.length == 0) {
                this.$notify({
                    title: '提示',
                    message: '请先勾选需要重新生成的数据',
                    type: 'error',
                    position: 'bottom-right'
                })
                return
            }
            const confirmData = {
                brandID: _this.brandID,
                orderIds: _this.selOrderIds,
                moduleID: this.CurrnetMID
            }
            AjaxHelper.post(_this.VoucherCreateNewUrl, confirmData).then(
                function (response) {
                    if (response.result.isSuccess) {
                        {
                            _this.$notify({
                                title: '提示',
                                message: response.result.successMsg,
                                type: 'success',
                                position: 'bottom-right'
                            })
                        }
                    } else {
                        _this.$notify({
                            title: '提示',
                            message: response.result.errorMsg,
                            type: 'error',
                            position: 'bottom-right'
                        })
                    }
                    _this.$refs.voucherTableData.clearSelection()
                    _this.$refs.refPagerBar.Refresh()
                }
            )
        },
        handleSelectionChange(val) {
            const _this = this
            if (_this.selOrder.length == 0) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            } else {
                let b = false
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        b = true
                        item.value = val
                    }
                })
                if (!b) {
                    _this.selOrder.push({
                        key: _this.$refs.refPagerBar.currentPage,
                        value: val
                    })
                }
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.tableData.find(
                            (tableRow) => tableRow.id === row.id
                        )
                        this.$refs.tableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.tableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.id === row.id)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (!_this.selOrder.find((item) => item.id === key.id)) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item.billNO !== row.billNO
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.tableData)
            } else {
                this.removeRows(this.tableData)
            }
        },
        errorHandler() {
            this.openloading = false
        },
        search() {
            this.openloading = true
            this.voucherQueryModel.isAll = this.isAll
            if (this.time != null && this.time != [] && this.time.length == 2) {
                this.voucherQueryModel.startTime = moment(this.time[0]).format(
                    'YYYY-MM-DD'
                )
                this.voucherQueryModel.endTime = moment(this.time[1]).format(
                    'YYYY-MM-DD'
                )
            }
            if (
                this.businesstime != null &&
                this.businesstime != [] &&
                this.businesstime.length == 2
            ) {
                this.voucherQueryModel.businessStartTime = moment(
                    this.businesstime[0]
                ).format('YYYY-MM-DD')
                this.voucherQueryModel.businessEndTime = moment(
                    this.businesstime[1]
                ).format('YYYY-MM-DD')
            }
            let confirmData = Object.assign({}, this.voucherQueryModel)
            if (this.voucherQueryModel.store == '') {
                let storeIDs = []
                this.storesList.map((x) => {
                    storeIDs.push(x.id)
                })
                confirmData.storeID = storeIDs.join(',')
            } else {
                const storeID = this.voucherQueryModel.storeID
                const storeItem = this.storesList.filter((x) => x.id == storeID)
                confirmData.storeID = storeID
            }
            confirmData.purchasedModuleConfId = this.CurrnetMID
            confirmData.brandId = this.brandID
            this.queryParam = Object.assign({}, confirmData)
        },

        getTableData(d) {
            this.tableData = d
            this.openloading = false
        },
        brandChange(val) {
            this.voucherQueryModel.storeID = ''
            this.storesList = this.stores.filter((x) => x.brandID === val)
        },
        statusSearch(item) {
            this.CurrnetMID = item.id
            this.isPos = false
            this.isCloud = false
            if (item.name.indexOf('餐饮') >= 0) {
                this.isPos = true
            } else {
                if (
                    item.name.indexOf('供应链') >= 0 ||
                    item.name.indexOf('SCM8') >= 0
                ) {
                    this.isCloud = true
                }
            }
            this.voucherQueryModel.storeID = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            if (this.brandList.length > 0) {
                this.brandID = this.brandList[0].id
                this.brandChange(this.brandID)
            }
            this.tableData = []
        },
        getModules() {
            const _this = this
            AjaxHelper.get(_this.VoucherCreateApi + '/GetModules')
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.isPos = false
                            _this.isCloud = false
                            if (firstItem.name.indexOf('餐饮') >= 0) {
                                _this.isPos = true
                            } else {
                                if (firstItem.name.indexOf('供应链') >= 0) {
                                    _this.isCloud = true
                                }
                            }
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            _this.brandList = response.result.brands.filter(
                                (x) => x.moduleID == firstItem.id
                            )
                            if (_this.brandList.length > 0) {
                                _this.brandID = _this.brandList[0].id
                                _this.brandChange(_this.brandID)
                            }
                        }
                    }
                    _this.openloading = false
                })
                .catch(function (error) {
                    _this.openloading = false
                    console.log(error)
                })
        }
    }
}
</script>

<style scoped>
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    height: calc(100vh - 154px) !important;
    overflow-y: auto;
}
</style>
